/* Non-commerce, source-model comparison shared by catalog, detail and compare pages. */
(() => {
  'use strict';

  const STORAGE_KEY = 'idf_compare_models_final';
  const LIMIT = 3;
  const MODELS = {
    PANDA818: { label: 'PANDA 818', route: '/pages/bandingkan-model?view=model-panda818' },
    RUSA818: { label: 'RUSA 818', route: '/pages/bandingkan-model?view=model-rusa818' }
  };
  let inMemorySelection = [];

  function normalize(code) {
    const normalized = String(code || '').trim().toUpperCase();
    return Object.prototype.hasOwnProperty.call(MODELS, normalized) ? normalized : null;
  }

  function uniqueValid(codes) {
    if (!Array.isArray(codes)) return [];
    const result = [];
    for (const code of codes) {
      const normalized = normalize(code);
      if (normalized && !result.includes(normalized)) result.push(normalized);
      if (result.length === LIMIT) break;
    }
    return result;
  }

  function readSelection() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === null ? inMemorySelection.slice() : uniqueValid(JSON.parse(stored));
    } catch (_) {
      return inMemorySelection.slice();
    }
  }

  function saveSelection(codes) {
    inMemorySelection = uniqueValid(codes);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(inMemorySelection)); } catch (_) { /* Browsing still works in memory. */ }
    renderAll();
  }

  function detailLink(code) {
    return MODELS[code].route;
  }

  function el(tag, text, className) {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  }

  function announce(message) {
    document.querySelectorAll('[data-idf-compare-status]').forEach((node) => { node.textContent = message; });
  }

  function imageFor(root, code) {
    const option = Array.from(root.querySelectorAll('.idf-compare__option')).find((node) => normalize(node.dataset.modelCode) === code);
    return option?.dataset.modelImage || null;
  }

  function renderComparison(root, selected) {
    const head = root.querySelector('[data-idf-compare-head]');
    const body = root.querySelector('[data-idf-compare-body]');
    const selectedList = root.querySelector('[data-idf-compare-selected]');
    if (!head || !body || !selectedList) return;

    const selectedHeading = el('h3', 'Model terpilih');
    const selectedItems = el('ul', undefined, 'idf-compare__selected-list');
    for (const code of selected) {
      const item = el('li');
      const name = el('span', 'Model ' + MODELS[code].label);
      const remove = el('button', 'Hapus', 'idf-compare__remove');
      remove.type = 'button';
      remove.dataset.idfCompareRemove = code;
      remove.setAttribute('aria-label', 'Hapus model ' + MODELS[code].label + ' dari perbandingan');
      item.append(name, remove);
      selectedItems.append(item);
    }
    if (selected.length) selectedList.replaceChildren(selectedHeading, selectedItems);
    else selectedList.replaceChildren(el('p', 'Belum ada model yang dipilih.'));

    const headerRow = el('tr');
    const firstHeading = el('th', 'Pilihan');
    firstHeading.scope = 'col';
    headerRow.append(firstHeading);
    for (const code of selected) {
      const cell = el('th');
      cell.scope = 'col';
      const imageURL = imageFor(root, code);
      if (imageURL) {
        const img = el('img', undefined, 'idf-compare__image');
        img.src = imageURL;
        img.alt = 'Foto referensi model ' + MODELS[code].label;
        img.loading = 'lazy';
        cell.append(img);
      } else {
        cell.append(el('span', 'Foto referensi sedang diperiksa', 'idf-compare__noimage'));
      }
      cell.append(el('span', 'Model ' + MODELS[code].label));
      headerRow.append(cell);
    }
    head.replaceChildren(headerRow);

    if (!selected.length) {
      const row = el('tr');
      const cell = el('td', 'Pilih model di atas untuk menampilkan perbandingan.');
      row.append(cell);
      body.replaceChildren(row);
      return;
    }

    const modelRow = el('tr');
    const modelLabel = el('th', 'Kode model');
    modelLabel.scope = 'row';
    modelRow.append(modelLabel);
    const detailRow = el('tr');
    const detailLabel = el('th', 'Halaman model');
    detailLabel.scope = 'row';
    detailRow.append(detailLabel);
    const imageRow = el('tr');
    const imageLabel = el('th', 'Foto referensi');
    imageLabel.scope = 'row';
    imageRow.append(imageLabel);
    const infoRow = el('tr');
    const infoLabel = el('th', 'Jenis');
    infoLabel.scope = 'row';
    infoRow.append(infoLabel);

    for (const code of selected) {
      modelRow.append(el('td', MODELS[code].label));
      const detailCell = el('td');
      const link = el('a', 'Lihat detail model ' + MODELS[code].label);
      link.href = detailLink(code);
      detailCell.append(link);
      detailRow.append(detailCell);
      imageRow.append(el('td', imageFor(root, code) ? 'Lihat foto di atas' : '—'));
      infoRow.append(el('td', 'Kipas meja karakter'));
    }
    body.replaceChildren(modelRow, detailRow, imageRow, infoRow);
  }

  function renderAll() {
    const selected = readSelection();
    document.querySelectorAll('[data-idf-compare-add][data-model-code]').forEach((button) => {
      const code = normalize(button.dataset.modelCode);
      if (!code) return;
      const isSelected = selected.includes(code);
      button.setAttribute('aria-disabled', String(isSelected));
      button.setAttribute('aria-label', (isSelected ? 'Model ' + MODELS[code].label + ' sudah dipilih' : 'Tambahkan model ' + MODELS[code].label + ' ke perbandingan'));
      button.textContent = isSelected ? 'Sudah dipilih' : 'Tambahkan';
    });
    document.querySelectorAll('[data-idf-compare]').forEach((root) => {
      const count = root.querySelector('[data-idf-compare-count]');
      if (count) count.textContent = String(selected.length);
      const status = root.querySelector('[data-idf-compare-status]');
      if (status) status.textContent = selected.length ? `${selected.length} model dipilih. Hapus pilihan atau buka detail untuk melanjutkan.` : 'Pilih model di bawah untuk mulai membandingkan.';
      renderComparison(root, selected);
    });
  }

  document.addEventListener('click', (event) => {
    const remove = event.target.closest?.('[data-idf-compare-remove]');
    if (remove) {
      const code = normalize(remove.dataset.idfCompareRemove);
      if (!code) return;
      saveSelection(readSelection().filter((item) => item !== code));
      announce('Model ' + MODELS[code].label + ' dihapus dari perbandingan.');
      return;
    }

    const add = event.target.closest?.('[data-idf-compare-add][data-model-code]');
    if (!add) return;
    const code = normalize(add.dataset.modelCode);
    if (!code) return;
    const selected = readSelection();
    if (selected.includes(code)) {
      announce('Model ' + MODELS[code].label + ' sudah dipilih.');
      return;
    }
    if (selected.length >= LIMIT) {
      announce('Maksimal tiga model. Hapus satu model sebelum menambah yang lain.');
      add.textContent = 'Maksimal 3 model';
      return;
    }
    saveSelection([...selected, code]);
    announce('Model ' + MODELS[code].label + ' ditambahkan ke perbandingan.');
  });

  window.addEventListener('storage', (event) => { if (event.key === STORAGE_KEY) renderAll(); });
  document.addEventListener('shopify:section:load', renderAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAll, { once: true });
  else renderAll();
})();
